import {update} from './ObjectHelper'

export interface HttpRequest {
    readonly verb: 'HEAD' | 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'
    readonly url: string
    readonly headers: { [key: string]: string }
    readonly body?: string | FormData
}

export function toRequest(httpRequest: HttpRequest): Request {
    return new Request(httpRequest.url, {
        method: httpRequest.verb,
        headers: new Headers(httpRequest.headers),
        body: httpRequest.body,
    })
}

export function authorize(
    token: string,
    httpRequest: HttpRequest,
): HttpRequest {
    return update({
        headers: update({
            Authorization: token,
        }, httpRequest.headers),
    }, httpRequest)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/HttpRequest.ts